export const createGetListsRequest = () => {
  return {
    url: "/lists",
    method: "GET",
  };
};

export const createGetListRequest = (id, page, per_page) => {
  return {
    url: "/lists/" + id,
    method: "GET",
    params: {
      page,
      per_page,
    },
  };
};

export const createGetListPostsRequest = (
  id,
  type,
  page,
  per_page,
  posts_published_from_timestamp = ""
) => {
  return {
    url: "/lists/" + id + "/posts",
    method: "GET",
    params: {
      status: type,
      page,
      per_page,
      posts_published_from_timestamp,
    },
  };
};

export const createNewListRequest = (
  icon,
  title,
  automated,
  hour_of_the_day_in_utc,
  email_alerts_enabled
) => {
  return {
    url: "/lists/",
    method: "POST",
    data: {
      icon,
      title,
      automated,
      hour_of_the_day_in_utc,
      email_alerts_enabled,
    },
  };
};

export const createUpdateListRequest = (
  id,
  icon,
  title,
  automated,
  hour_of_the_day_in_utc,
  email_alerts_enabled
) => {
  return {
    url: "/lists/" + id,
    method: "PUT",
    data: {
      icon,
      title,
      automated,
      hour_of_the_day_in_utc,
      email_alerts_enabled,
    },
  };
};

export const createGetListContactsRequest = (id, page, per_page) => {
  return {
    url: "/lists/" + id + "/contacts",
    method: "get",
    params: {
      page,
      per_page,
    },
  };
};

export const createNewListContactRequest = (id, profile_url) => {
  return {
    url: "/lists/" + id + "/contacts",
    method: "POST",
    data: {
      profile_url,
    },
  };
};

export const createFetchListPostsRequest = (id) => {
  return {
    url: "/lists/" + id + "/fetch_posts",
    method: "POST",
  };
};

export const createAddMultipleContactsRequest = (id, profile_urls) => {
  return {
    url: "/lists/" + id + "/contacts/v2",
    method: "POST",
    data: {
      profile_urls,
    },
  };
};

// Confirm step for the commenter flow: sends full contact details (from the
// preview) so the server backfills them without re-enriching. Same endpoint as
// the legacy profile_urls form; when both are present the server prefers
// `contacts`.
export const createAddContactsWithDetailsRequest = (id, contacts) => {
  return {
    url: "/lists/" + id + "/contacts/v2",
    method: "POST",
    data: {
      contacts,
    },
    // The commenter flow shows its own inline "Add selected" progress, so
    // suppress the app-wide loading overlay.
    disableLoading: true,
  };
};

export const createPreviewCommentersRequest = (id, post_url) => {
  return {
    url: "/lists/" + id + "/commenters/preview",
    method: "POST",
    data: {
      post_url,
    },
    // The modal shows its own inline progress state for this long (~8-15s)
    // call, so suppress the app-wide loading overlay.
    disableLoading: true,
  };
};

export const createDeleteContactRequest = (listId, contactId) => {
  return {
    url: "/lists/" + listId + "/contacts/" + contactId,
    method: "DELETE",
  };
};

export const createArchiveListRequest = (listId) => {
  return {
    url: "/lists/" + listId + "/archive",
    method: "POST",
  };
};

export const createDiscardPostRequest = (listId, postId) => {
  return {
    url: "/lists/" + listId + "/posts/" + postId + "/discard",
    method: "POST",
  };
};

export const createDiscardAllPostsRequest = (listId) => {
  return {
    url: "/lists/" + listId + "/posts/discard_all",
    method: "POST",
  };
};

export const createGetLatestStatusRequest = (listId) => {
  return {
    url: "/lists/" + listId + "/latest_status",
    method: "GET",
  };
};
